import { useMemo } from 'react';
import {
  calculateRemainingTime,
  getRelevantTasksForProgress,
  isTaskCompleteForProgress,
} from '../../../FlowchartView/utils/progressUtils';

/**
 * Decision-aware completion counts plus recursive remaining-time totals.
 */
export function useCampaignProgressStats(tasks, statuses, nestedSprints = [], allSprints = []) {
  return useMemo(() => {
    const taskList = tasks ?? [];
    const { relevantTasks, effectiveTotal } = getRelevantTasksForProgress(taskList);
    const completedCount = relevantTasks.filter((task) =>
      isTaskCompleteForProgress(task, statuses),
    ).length;
    const { totalMinutes, minMinutes, missingEstCount, items } = calculateRemainingTime(
      taskList,
      statuses,
      nestedSprints,
      allSprints,
    );

    return {
      completedCount,
      totalCount: effectiveTotal,
      remainingMinutes: totalMinutes,
      remainingMinMinutes: minMinutes,
      missingEstCount,
      remainingBreakdown: items,
    };
  }, [tasks, statuses, nestedSprints, allSprints]);
}
